import { CONFIG } from "~/config";
import { node } from "~/util/dom";
import { getMobilePromoLink2, LOCALE_STRINGS } from "~/util/mobile-promo";
import { getMobileOperatingSystem } from "~/util/userweb";
import * as localStorageProvider from "~/es6/localstorage";
import * as sessionStorageProvider from "~/es6/sessionstorage";

const SESSION_STORAGE_KEY = "mobileAppPromo";
const LOCAL_STORAGE_KEY = "androidAppPromotionShow";

function shouldShow(): boolean {
	try {
		const value = CONFIG.isMapyczApp
			|| CONFIG.dontShowAndroidPromo
			|| sessionStorageProvider.getItem(SESSION_STORAGE_KEY)
			|| window.location.search.indexOf("mobilepromo=1") > -1
			|| CONFIG.urlData?.indexOf("mobilepromo=1") > -1
			|| (parseInt(localStorageProvider.getItem(LOCAL_STORAGE_KEY)) || -Infinity) > Date.now() - (30 * 24 * 60 * 60 * 1000); // ukazujeme az po 30 dnech, kdyz jsme klikli na nyni ne

		return !value;
	} catch (ex) {
		//
	}

	return true;
}

export default class AndroidAppPromotion {
	_container: HTMLDivElement;

	_scrim: HTMLDivElement;

	constructor() {
		const system = getMobileOperatingSystem();
		const and = system === "a";
		const ios = system === "i";

		// default je, ze to chceme ukazat
		const show = shouldShow() && (and || ios);

		// pokud dava smysl zobrazit, tak zobrazime
		if (show) {
			// pro priste uz nebudeme ukazovat
			sessionStorageProvider.setItem(SESSION_STORAGE_KEY, new Date().getTime().toString());

			localStorageProvider.removeItem(LOCAL_STORAGE_KEY);

			Mapy.getComponent("logger").log("promo_impress", { type: "banner_responsive" });

			// sestavime hlasku
			this._container = node("div", { className: "android-app-promotion" });
			this._scrim = node("div", { className: "android-app-promotion__scrim" });
			const title = node("h1", { innerHTML: LOCALE_STRINGS[CONFIG.detectLang].title });
			const subtitle = node("p", { innerHTML: LOCALE_STRINGS[CONFIG.detectLang].desc });
			const actions = node("div");
			const url = getMobilePromoLink2(system);
			const downloadButton = node("a", { href: url, innerHTML: LOCALE_STRINGS[CONFIG.detectLang].downloadBtn, className: "button primary" });
			const closeButton = node("button", { type: "button", innerHTML: LOCALE_STRINGS[CONFIG.detectLang].notNowBtn });

			this._container.appendChild(title);
			this._container.appendChild(subtitle);

			downloadButton.setAttribute("data-log-action", "promo");
			downloadButton.setAttribute("data-log-type", `banner_promo_${and ? "android" : "iOS"}_store_download`);
			actions.appendChild(downloadButton);

			closeButton.setAttribute("data-log-action", "promo");
			closeButton.setAttribute("data-log-type", `banner_promo_${and ? "android" : "iOS"}_not_now`);
			closeButton.addEventListener("click", () => {
				localStorageProvider.setItem(LOCAL_STORAGE_KEY, Date.now().toString());
				this.close();
			});
			actions.appendChild(closeButton);
			this._container.appendChild(actions);

			// hodime do DOMu
			document.body.appendChild(this._scrim);
			document.body.appendChild(this._container);
		}
	}

	close() {
		if (this._container) {
			this._container.remove();
			this._scrim.remove();
		}
	}
}
